import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var CommunicationService = /** @class */ (function () {
    function CommunicationService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'eqcpcc': this._global.find(_GlobalNS.paths.eqcpcc)
            })
        };
    }
    CommunicationService.prototype.getphone = function (ResourceId, ResourceType, Type) {
        var api = _GlobalNS.api.general.phone;
        var params = new HttpParams().set('ResourceId', ResourceId.toString()).set('ResourceType', ResourceType.toString());
        if (typeof Type !== 'undefined') {
            params.set('Type', Type.toString());
        }
        this.httpOptions['params'] = params;
        return this._http.get("" + api, this.httpOptions);
    };
    CommunicationService.prototype.updatePhone = function (Data) {
        var api = _GlobalNS.api.general.phone;
        var params = new HttpParams().set('eqrf', this._global.find(_GlobalNS.paths.eqrf));
        this.httpOptions['params'] = params;
        return this._http.post("" + api, Data, this.httpOptions);
    };
    CommunicationService.prototype.getAddress = function (ResourceId, ResourceType, Type) {
        var api = _GlobalNS.api.general.address;
        var params = new HttpParams().set('ResourceId', ResourceId.toString()).set('ResourceType', ResourceType.toString());
        if (typeof Type !== 'undefined') {
            params.set('Type', Type.toString());
        }
        this.httpOptions['params'] = params;
        return this._http.get("" + api, this.httpOptions);
    };
    CommunicationService.prototype.updateAddress = function (Data) {
        var api = _GlobalNS.api.general.address;
        var params = new HttpParams().set('eqrf', this._global.find(_GlobalNS.paths.eqrf));
        this.httpOptions['params'] = params;
        return this._http.post("" + api, Data, this.httpOptions);
    };
    CommunicationService.prototype.getStateslabelValue = function () {
        return [
            { 'label': 'State', 'value': '' },
            { 'label': 'AK', 'value': 'AK' },
            { 'label': 'AL', 'value': 'AL' },
            { 'label': 'AR', 'value': 'AR' },
            { 'label': 'AS', 'value': 'AS' },
            { 'label': 'AZ', 'value': 'AZ' },
            { 'label': 'CA', 'value': 'CA' },
            { 'label': 'CO', 'value': 'CO' },
            { 'label': 'CT', 'value': 'CT' },
            { 'label': 'DC', 'value': 'DC' },
            { 'label': 'DE', 'value': 'DE' },
            { 'label': 'FL', 'value': 'FL' },
            { 'label': 'FM', 'value': 'FM' },
            { 'label': 'GA', 'value': 'GA' },
            { 'label': 'GU', 'value': 'GU' },
            { 'label': 'HI', 'value': 'HI' },
            { 'label': 'IA', 'value': 'IA' },
            { 'label': 'ID', 'value': 'ID' },
            { 'label': 'IL', 'value': 'IL' },
            { 'label': 'IN', 'value': 'IN' },
            { 'label': 'KS', 'value': 'KS' },
            { 'label': 'KY', 'value': 'KY' },
            { 'label': 'LA', 'value': 'LA' },
            { 'label': 'MA', 'value': 'MA' },
            { 'label': 'MD', 'value': 'MD' },
            { 'label': 'ME', 'value': 'ME' },
            { 'label': 'MH', 'value': 'MH' },
            { 'label': 'MI', 'value': 'MI' },
            { 'label': 'MN', 'value': 'MN' },
            { 'label': 'MO', 'value': 'MO' },
            { 'label': 'MP', 'value': 'MP' },
            { 'label': 'MS', 'value': 'MS' },
            { 'label': 'MT', 'value': 'MT' },
            { 'label': 'NC', 'value': 'NC' },
            { 'label': 'ND', 'value': 'ND' },
            { 'label': 'NE', 'value': 'NE' },
            { 'label': 'NH', 'value': 'NH' },
            { 'label': 'NJ', 'value': 'NJ' },
            { 'label': 'NM', 'value': 'NM' },
            { 'label': 'NV', 'value': 'NV' },
            { 'label': 'NY', 'value': 'NY' },
            { 'label': 'OH', 'value': 'OH' },
            { 'label': 'OK', 'value': 'OK' },
            { 'label': 'OR', 'value': 'OR' },
            { 'label': 'PA', 'value': 'PA' },
            { 'label': 'PR', 'value': 'PR' },
            { 'label': 'PW', 'value': 'PW' },
            { 'label': 'RI', 'value': 'RI' },
            { 'label': 'SC', 'value': 'SC' },
            { 'label': 'SD', 'value': 'SD' },
            { 'label': 'TN', 'value': 'TN' },
            { 'label': 'TX', 'value': 'TX' },
            { 'label': 'UT', 'value': 'UT' },
            { 'label': 'VA', 'value': 'VA' },
            { 'label': 'VI', 'value': 'VI' },
            { 'label': 'VT', 'value': 'VT' },
            { 'label': 'WA', 'value': 'WA' },
            { 'label': 'WI', 'value': 'WI' },
            { 'label': 'WV', 'value': 'WV' },
            { 'label': 'WY', 'value': 'WY' }
        ];
    };
    CommunicationService.ngInjectableDef = i0.defineInjectable({ factory: function CommunicationService_Factory() { return new CommunicationService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: CommunicationService, providedIn: "root" });
    return CommunicationService;
}());
export { CommunicationService };
